// src/ConsumerApp/Screens/Account/components/OrderHelpCard.js

import React from 'react';
import ChatCircle from '../../../../assets/icons/ChatCircle.svg';
import Phone from '../../../../assets/icons/Phone.svg';

const SUPPORT_PHONE_NUMBER = '+918247895454';
const WHATSAPP_PHONE_NUMBER = '918639065454';

export default function OrderHelpCard({ orderNumber = '' }) {
  const handleWhatsApp = () => {
    const msg = encodeURIComponent(`Hi, I need help with my order ${orderNumber}`);
    window.open(`https://wa.me/${WHATSAPP_PHONE_NUMBER}?text=${msg}`, '_blank');
  };

  const handlePhone = () => {
    window.location.href = `tel:${SUPPORT_PHONE_NUMBER}`;
  };

  return (
    <div style={styles.helpCard}>
      <span style={styles.helpText}>Need help with this Order?</span>
      <div style={styles.helpButtonGroup}>
        <button style={styles.helpBtn} onClick={handleWhatsApp} type="button">
          <img src={ChatCircle} alt="chat" style={{ width: 16, height: 16 }} />
          <span>Chat</span>
        </button>
        <button style={styles.helpBtn} onClick={handlePhone} type="button">
          <img src={Phone} alt="call" style={{ width: 16, height: 16 }} />
          <span>Call</span>
        </button>
      </div>
    </div>
  );
}

const styles = {
  helpCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #CBD5E1',
    borderRadius: 12,
    padding: 14,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  helpText: { fontSize: 13, fontWeight: '600', color: '#2B2A29' },
  helpButtonGroup: { display: 'flex', gap: 8 },
  helpBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid #CBD5E1',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    padding: '6px 14px',
    fontSize: 12,
    fontWeight: '600',
    cursor: 'pointer',
  },
};